export default __webpack_public_path__ + "static/bus-tracking-system-enhancing-student-safety-6547b884548af928db4fc663d8296e80.jpg";